import { render, staticRenderFns } from "./WithdrawalWinnings.vue?vue&type=template&id=7b530e48&scoped=true&"
import script from "./WithdrawalWinnings.vue?vue&type=script&lang=js&"
export * from "./WithdrawalWinnings.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawalWinnings.vue?vue&type=style&index=0&id=7b530e48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b530e48",
  null
  
)

export default component.exports